
export const getRoomTypeLabel = (roomTypeCode) => {

    switch (roomTypeCode) {
        case 0:
            return '-';
        case 1:
            return '다인실';
        case 2:
            return 'VIP실';
        case 3:
            return '복도';
        case 4:
            return '욕실';
        case 5:
            return '화장실';
        case 6:
            return '기타';
        default:
            return 'Unknown :'+ roomTypeCode;
    }
}


export const getRoomTypes = () => {

    return [
        {roomTypeCode : 1, roomTypeLabel : '다인실'},
        {roomTypeCode : 2, roomTypeLabel : 'VIP실'},
        {roomTypeCode : 3, roomTypeLabel : '복도'},
        {roomTypeCode : 4, roomTypeLabel : '욕실'},
        {roomTypeCode : 5, roomTypeLabel : '화장실'},
        {roomTypeCode : 6, roomTypeLabel : '기타'}
    ];
}

export const getRoomTypeRow = (roomTypeCode) => {

    switch (roomTypeCode) {
        case 1:
            return {roomTypeCode : 1, roomTypeLabel : '다인실'};
        case 2:
            return {roomTypeCode : 2, roomTypeLabel : 'VIP실'};
        case 3:
            return {roomTypeCode : 3, roomTypeLabel : '복도'};
        case 4:
            return {roomTypeCode : 4, roomTypeLabel : '욕실'};
        case 5:
            return {roomTypeCode : 5, roomTypeLabel : '화장실'};
        case 6:
            return {roomTypeCode : 6, roomTypeLabel : '기타'};

        default:
            return {};
        //     return 'Unknown :'+ roomTypeCode;
    }
}
